/**
 * Date Utils
 * https://codesandbox.io/s/date-utils-sujzc
 */

export function returnDate(dateObj) {
    // Check if is a date object.
    if (dateObj instanceof Date === false) {
        return false;
    }

    // Check if is valid.
    if (isNaN(dateObj.getTime())) {
        return false;
    }

    return dateObj;
}

export function addLeadingZero(value) {
    return value < 10 ? `0${value}` : value;
}

export function formatTimeAMPM(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';

    hours %= 12;
    hours = hours === 0 ? 12 : hours;
    minutes = addLeadingZero(minutes);

    return `${hours}:${minutes} ${ampm}`;
}

/**
 * Parse the given date and return a date object or false.
 *
 * @param {String} dateStr
 * @return {(Date|false)}
 * @api public
 */
export function parseDate(dateStr) {
    let matches;
    const currDate = new Date();

    // Check for time:
    // - 17:24
    // - 17:24:15
    matches = dateStr.match(/^([0-9]{2}):([0-9]{2})(?::([0-9]{2}))?$/);

    if (matches !== null) {
        const [, hour, minutes, seconds] = matches;

        return returnDate(
            new Date(
                currDate.getFullYear(),
                currDate.getMonth(),
                currDate.getDay(),
                hour,
                minutes,
                seconds || currDate.getSeconds(),
            ),
        );
    }

    // Check for date and time - format 1:
    // - 2019-07-20
    // - 2019-07-20 17:24
    // - 2019-07-20 17:24:15
    // - 2019-07-20T17:24
    matches = dateStr.match(
        /^([0-9]{4})-([0-9]{2})-([0-9]{2})(?:(?:\s|T)([0-9]{2}):([0-9]{2})(?::([0-9]{2}))?)?$/,
    );

    if (matches !== null) {
        const [, year, month, day, hour, minutes, seconds] = matches;

        return returnDate(
            new Date(
                year,
                month - 1,
                day,
                hour || currDate.getHours(),
                minutes || currDate.getMinutes(),
                seconds || currDate.getSeconds(),
            ),
        );
    }

    // Check for date - format 2
    // Date format: 25-Aug-2019
    matches = dateStr.match(/^([0-9]{1,2})-([A-z]{3})-([0-9]{4})$/);

    if (matches !== null) {
        const [, day, month, year] = matches;

        return returnDate(new Date(`${day} ${month}, ${year}`));
    }

    // Check for date and time - format 3
    // Date format: 07-04-2019 (month-day-year)
    // Date format: 07-04-2019 17:24
    // Date format: 07-04-2019 17:24:15
    matches = dateStr.match(
        /^([0-9]{2})-([0-9]{2})-([0-9]{4})(?:\s([0-9]{2}):([0-9]{2})(?::([0-9]{2}))?)?$/,
    );

    if (matches !== null) {
        const [, month, day, year, hour, minutes, seconds] = matches;

        return returnDate(
            new Date(
                year,
                parseInt(month, 10) - 1,
                day,
                hour || currDate.getHours(),
                minutes || currDate.getMinutes(),
                seconds || currDate.getSeconds(),
            ),
        );
    }

    return false;
}
